import { EncounterChip } from './EncounterChip';
import { formatCalendarDate } from '@/lib/utils/date';
import type { CalendarEntry } from '../api/calendar-api';

/**
 * The narrow rendering.
 *
 * A 7-column grid at phone width gives cells about 45px wide, which fits a date
 * number and nothing else — so this is a different rendering rather than a
 * squeezed one, matching how the encounters page splits its table and card list.
 * Empty days are omitted entirely: scrolling past three weeks of blanks to reach
 * Thursday is not navigation.
 */
export function AgendaList({ entries, onSelectDate }: { entries: CalendarEntry[]; onSelectDate?: (date: string) => void }) {
  const days = [...new Set(entries.map((entry) => entry.encounter_date))].sort();

  if (days.length === 0) {
    return (
      <p className="rounded-[16px] border border-border p-6 text-center text-sm text-muted-foreground">
        Nothing scheduled this month.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {days.map((day) => (
        <div key={day} className="flex flex-col gap-2">
          <h3 className="text-xs font-medium tracking-[0.14em] text-muted-foreground uppercase">
            <button type="button" className="hover:text-primary hover:underline" onClick={() => onSelectDate?.(day)}>
              {formatCalendarDate(day)}
            </button>
          </h3>
          {entries
            .filter((entry) => entry.encounter_date === day)
            .map((entry) => (
              <EncounterChip key={entry.id} entry={entry} className="py-2 text-[13px]" />
            ))}
        </div>
      ))}
    </div>
  );
}
